/**
 * MultiLikes 店舗お気に入り（テーマ側実装）
 *
 * テーマ独自の店舗一覧（sections/custom-stores-list.liquid）のボタンを
 * MultiLikes の App Proxy に接続する。
 *
 * - 一覧取得 : GET  {defaultUrl}?metaobject_type=multilikes_store&customer_id=&limit=&after=
 * - 登録/解除: POST {defaultUrl}  target_type=metaobject&action=add|remove&metaobject_type=&metaobject_id=
 *
 * ボタン側の data 属性は Laline（tsi-laline / sections/laline-shop-list.liquid）と互換。
 *
 * 通信はボタンが押された時にだけ行う。ページ表示時は API を叩かず、
 * ボタンは Liquid が出力したまま表示しておく（表示後に消えるちらつきを避けるため）。
 * 最初の1クリックで店舗一覧を取得し、ページ内すべてのボタンの登録状態をまとめて反映する。
 */
(function () {
  'use strict';

  if (window.__multilikesStoreWishlistLoaded) return;
  window.__multilikesStoreWishlistLoaded = true;

  var BUTTON_SELECTOR = '[data-multilikes-store-button]';
  var METAOBJECT_TYPE = 'multilikes_store';
  var PAGE_SIZE = 100;
  var MAX_PAGES = 20;
  var ERROR_TEXT = 'お気に入りの更新に失敗しました。時間をおいて再度お試しください。';

  var storeIndexPromise = null;
  var instances = [];

  function normalize(value) {
    if (value === undefined || value === null) return '';
    var text = String(value);
    if (typeof text.normalize === 'function') text = text.normalize('NFKC');
    return text.replace(/[\s　]/g, '').toLowerCase();
  }

  function getConfig() {
    return window.multilikesConfig || null;
  }

  function fieldValue(item, key) {
    var fields = (item && item.fields) || [];
    for (var i = 0; i < fields.length; i++) {
      if (fields[i] && fields[i].key === key) return fields[i].value;
    }
    return null;
  }

  async function fetchStores(baseUrl, customerId) {
    var items = [];
    var after = null;

    for (var page = 0; page < MAX_PAGES; page++) {
      var params = new URLSearchParams({
        metaobject_type: METAOBJECT_TYPE,
        limit: String(PAGE_SIZE)
      });
      if (customerId) params.set('customer_id', String(customerId));
      if (after) params.set('after', after);

      var response = await fetch(baseUrl + '?' + params.toString(), {
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) throw new Error('店舗一覧の取得に失敗しました (status ' + response.status + ')');

      var json = await response.json();
      if (json && json.error) throw new Error(json.error);

      var data = Array.isArray(json && json.data) ? json.data : [];
      items = items.concat(data);

      var pageInfo = (json && json.pageInfo) || {};
      if (!pageInfo.hasNextPage || !pageInfo.endCursor) break;
      after = pageInfo.endCursor;
    }

    return items;
  }

  function buildIndex(items) {
    var byHandle = new Map();
    var byName = new Map();

    items.forEach(function (item) {
      if (!item || !item.id) return;

      var handleKey = normalize(item.handle);
      if (handleKey && !byHandle.has(handleKey)) byHandle.set(handleKey, item);

      [item.displayName, fieldValue(item, 'name')].forEach(function (name) {
        var nameKey = normalize(name);
        if (nameKey && !byName.has(nameKey)) byName.set(nameKey, item);
      });
    });

    return { byHandle: byHandle, byName: byName };
  }

  function loadStoreIndex(baseUrl, customerId) {
    if (!storeIndexPromise) {
      storeIndexPromise = fetchStores(baseUrl, customerId)
        .then(buildIndex)
        .catch(function (error) {
          // 失敗したPromiseをキャッシュし続けると再試行できなくなるため破棄する
          storeIndexPromise = null;
          throw error;
        });
    }
    return storeIndexPromise;
  }

  function resolveItem(index, button) {
    var handleKey = normalize(button.dataset.storeHandle || button.dataset.storeId);
    if (handleKey && index.byHandle.has(handleKey)) return index.byHandle.get(handleKey);

    var nameKey = normalize(button.dataset.storeTitle);
    if (nameKey && index.byName.has(nameKey)) return index.byName.get(nameKey);

    return null;
  }

  /** 取得した一覧を、ページ内のすべてのボタンへ一度に反映する */
  function syncAll(index) {
    var unmatched = [];

    instances.forEach(function (instance) {
      if (instance.synced) return;
      instance.synced = true;

      var item = resolveItem(index, instance.button);
      if (!item) {
        unmatched.push(instance.button.dataset.storeTitle || instance.button.dataset.storeHandle || '(名称なし)');
        return;
      }

      instance.metaobjectId = String(item.id);
      instance.button.dataset.metaobjectId = instance.metaobjectId;
      instance.setState(item.isInWishlist === true);
    });

    if (unmatched.length) {
      console.warn(
        '[multilikes-store] メタオブジェクト（' + METAOBJECT_TYPE + '）と一致する店舗が見つかりません: ' +
          unmatched.join(' / ')
      );
    }
  }

  function StoreWishlistButton(button) {
    this.button = button;
    this.labelElement = button.querySelector('.c-stores__btn-favorite-text');
    this.storeTitle = button.dataset.storeTitle || '';
    this.textAdd = button.dataset.textAdd || 'お気に入り登録';
    this.textRemove = button.dataset.textRemove || 'お気に入り登録済み';
    this.isInWishlist = false;
    this.metaobjectId = null;
    this.synced = false;

    var self = this;
    button.addEventListener('click', function () {
      return self.onClick();
    });
  }

  StoreWishlistButton.prototype.render = function () {
    var label = this.isInWishlist ? this.textRemove : this.textAdd;
    this.button.classList.toggle('is-active', this.isInWishlist);
    this.button.setAttribute('aria-pressed', this.isInWishlist ? 'true' : 'false');
    if (this.labelElement) this.labelElement.textContent = label;
    if (this.storeTitle) {
      this.button.setAttribute(
        'aria-label',
        this.storeTitle + 'を' + (this.isInWishlist ? 'お気に入りから削除' : 'お気に入りに登録')
      );
    }
  };

  StoreWishlistButton.prototype.setState = function (isInWishlist) {
    this.isInWishlist = isInWishlist === true;
    this.render();
  };

  // 通常は snippets/multilikes-login-modal.liquid がキャプチャフェーズで先に処理するため
  // ここまで来ないが、モーダルが出力されていない場合の保険としてログイン画面へ送る
  StoreWishlistButton.prototype.promptLogin = function () {
    var modal = window.MultilikesLoginModal;
    if (modal && typeof modal.open === 'function') {
      modal.open();
      return;
    }
    window.location.href = '/account/login?return_url=' + encodeURIComponent(window.location.href);
  };

  StoreWishlistButton.prototype.onClick = async function () {
    var config = getConfig();
    if (!config || !config.defaultUrl) {
      console.warn('[multilikes-store] MultiLikes のアプリ埋め込み（wishlist_assets）が有効になっていません。');
      return;
    }
    if (!config.customerId) {
      this.promptLogin();
      return;
    }
    if (this.button.disabled) return;

    // 初回クリック時にだけ店舗一覧を取得し、ページ内すべてのボタンへ反映する
    if (!this.synced) {
      this.button.disabled = true;
      try {
        var index = await loadStoreIndex(config.defaultUrl, config.customerId);
        syncAll(index);
      } catch (error) {
        console.error('[multilikes-store] 店舗一覧の取得に失敗しました', error);
        window.alert(ERROR_TEXT);
        return;
      } finally {
        this.button.disabled = false;
      }

      if (!this.metaobjectId) {
        window.alert(ERROR_TEXT);
        return;
      }

      // 既にお気に入り登録済みだった場合は、表示を実態に合わせるだけで解除はしない
      // （未登録の見た目で押したユーザーの意図と逆の操作になるため）
      if (this.isInWishlist) return;
    }

    if (!this.metaobjectId) {
      window.alert(ERROR_TEXT);
      return;
    }

    await this.toggle(config);
  };

  StoreWishlistButton.prototype.toggle = async function (config) {
    var previousState = this.isInWishlist;
    var nextState = !previousState;

    this.setState(nextState);
    this.button.disabled = true;

    try {
      var response = await fetch(config.defaultUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Accept: 'application/json'
        },
        body: new URLSearchParams({
          target_type: 'metaobject',
          customer_id: String(config.customerId),
          action: nextState ? 'add' : 'remove',
          metaobject_type: METAOBJECT_TYPE,
          metaobject_id: this.metaobjectId
        })
      });

      var json = await response.json().catch(function () {
        return null;
      });

      if (!response.ok || (json && json.error)) {
        throw new Error((json && json.error) || 'status ' + response.status);
      }

      var payload = (json && json.data) || {};
      this.setState(typeof payload.isInWishlist === 'boolean' ? payload.isInWishlist : nextState);
    } catch (error) {
      this.setState(previousState);
      console.error('[multilikes-store] お気に入りの更新に失敗しました', error);
      window.alert(ERROR_TEXT);
    } finally {
      this.button.disabled = false;
    }
  };

  /** ボタンにクリックリスナーを付けるだけ。ここでは通信しない。 */
  function init(root) {
    var scope = root || document;
    Array.prototype.slice.call(scope.querySelectorAll(BUTTON_SELECTOR)).forEach(function (button) {
      if (button.dataset.multilikesInitialized === 'true') return;
      button.dataset.multilikesInitialized = 'true';
      instances.push(new StoreWishlistButton(button));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
    // 取得済みの一覧があれば、追加されたボタンにも即座に反映する
    if (!storeIndexPromise) return;
    storeIndexPromise.then(syncAll).catch(function () {});
  });
})();
